export default __webpack_public_path__ + "static/shop-new-arrivals-mobile-30a8d00e3fa5f26938c8631864b74934.webp";